export const Card = ({ title, value }) => {
    return (
        <div className="card-dashboards">
            <div className="card-title-dashboards">{title}</div>
            <div className="card-value-dashboards">{value}</div>
        </div>
    );
};
